
import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "providers/ThemeProvider";
import { Container, Card } from "components/common";
import { Wrapper, Grid, Item, Content, Stats } from "./styles";
import virtuera from "../../../assets/illustrations/virtuera.png";
import Quantale from "../../../assets/illustrations/quantale.png";
import gssoc from "../../../assets/illustrations/gssoc.png";
import styled from 'styled-components';
import { HoverableCard } from 'react-hoverable-card'
import 'react-hoverable-card/dist/index.css'
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";

export const Experience = () => {
  const { theme } = useContext(ThemeContext);
  const [company, setCompany] = useState([]);
  useEffect(() => {
    const companies = [
      {
        name: "Quantale",
        id: 1,
        svn_url: "https://quantale.io",
        description: "Full-Stack Developer, analysed and designed algorithms for stock analysis and worked with the team to develop and test several features of the application.",
        start: "October, 2021",
        end: "Present",
        img: Quantale
      },
      {
        name: "Virtuera",
        id: 2,
        svn_url: "https://virtuera.org/",
        description: "Backend Developer, added and tested features such as assessments for internships and skills, blogs by the admin and badges for students based on scores.",
        start: "January, 2021",
        end: "April, 2021",
        img: virtuera
      },
      {
        name: "Delta Force",
        id: 3,
        svn_url: "https://delta.nitt.edu",
        description: "Software developer at the official programming club in NIT Trichy.",
        start: "April, 2021",
        end: "Present",
        img: "https://delta.nitt.edu/images/deltaLogoGreen.png"
      },
      {
        name: "GSSOC'21",
        id: 4,
        svn_url: "https://gssoc.girlscript.tech/profile.html?id=nishihere19",
        description: "Was a participant in the program aimed at increasing open-source culture among students",
        start: "March, 2021",
        end: "May, 2021",
        img: gssoc
      }
    ];
    setCompany(companies);
  }, []);

  const BigTitle = styled.a({
    textTransform: "uppercase",
    textDecoration: "none",
    fontSize: "1.3rem",
    color: `${theme === "light" ? "#000" : "#fff"} !important`,
  });
  const Heading = styled.h1({
    fontSize:"3rem",
    color:`rgb(228 93 93) !important`,
    '@media(max-width: 700px)': {
      fontSize: '1.5rem'
    }
  });
  return (
    <Wrapper as={Container} id="experience">
      {<Heading theme={theme}>Experience</Heading>}
      <Grid theme={theme}>
        {company.map((node) => (
                    <ScrollAnimation animateIn="animate__zoomIn" duration="3" >
          <div theme={theme} key={node.id}>
          <HoverableCard
          cardTitle={`${node.start} - ${node.end}`}
          cardDescription={`${node.description}`}
          cardImage={node.img}
          hoverBgColor="grey"
        />
        <BigTitle
        theme={theme} href={node.svn_url}>{node.name}</BigTitle>
        </div></ScrollAnimation>
        ))}
      </Grid>
    </Wrapper>
  );
};
